import React from 'react'
import Panel from './../../components/Panel'
import ContactContainer from './../../containers/ContactContainer'

const Contact = () => (
  <div className='login'>
    <Panel
      featurePanel
      mainPanel={<ContactContainer isLogin />}
    />
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/routes/Contact/index.js